import { SchemaTypes } from '@allesauto/graphql';
import translate from '@allesauto/i18n';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';

export interface HighlightsProps {
  highlights?: SchemaTypes.VehicleDetail['highlights'];
  configurationElements?:
    | SchemaTypes.Maybe<SchemaTypes.Maybe<SchemaTypes.ConfigurationElement>[]>
    | undefined;
}

const Highlights: FC<React.PropsWithChildren<HighlightsProps>> = ({
  highlights,
  configurationElements,
}) => {
  const maxHighlights = 11;
  const intl = useIntl();

  const groupedConfigurationElements = configurationElements?.map(
    (item) => item?.name
  );

  const configurationElementsPresent =
    configurationElements && configurationElements?.length > 0;

  return (
    <div className="col-end-24 col-start-2 pt-[39px]" data-hide-for-print="">
      <h2
        className="font-headline pb-40px text-grey100 text-headline3"
        id="label--highlights-title"
      >
        {configurationElementsPresent
          ? translate(intl, 'ui.PDP.EXTRAS_CONDITION.MY_SELECTED_EQUIPMENT')
          : translate(intl, 'ui.PDP.HIGHLIGHTS.HEADLINE')}
      </h2>
      <div className="flex flex-col flex-wrap pb-80px md:flex-row">
        {configurationElementsPresent
          ? groupedConfigurationElements &&
            groupedConfigurationElements
              .slice(0, maxHighlights)
              .map((item, index) => {
                return (
                  <span
                    key={index}
                    className="bg-grey10 mb-20px mr-20px rounded-[40px] whitespace-nowrap sm:px-20px sm:py-5px sm:w-fit md:px-30px md:py-15px md:w-auto"
                    id={`label--highlights-${index}`}
                  >
                    {item}
                  </span>
                );
              })
          : highlights &&
            highlights.slice(0, maxHighlights).map((item, index) => {
              return (
                <span
                  key={index}
                  className="bg-grey10 mb-20px mr-20px rounded-[40px] whitespace-nowrap sm:px-20px sm:py-5px sm:w-fit md:px-30px md:py-15px md:w-auto"
                  id={`label--highlights-${index}`}
                >
                  {item}
                </span>
              );
            })}
      </div>
    </div>
  );
};

export default Highlights;
